<template>
  <b>
    <vx-card class="mt-3">
      <vs-table :sst="true" v-model="selected" pagination max-items="10" search :data="users">
        <template slot="header">
          <vs-button
            style="margin-left:5px;margin-top:5px"
            icon-pack="feather"
            icon="icon-plus"
            @click="popupAdd=true"
          >Add User</vs-button>
        </template>
        <template slot="thead">
          <vs-th sort-key="username">Username</vs-th>
          <vs-th sort-key="gender">Gender</vs-th>
          <vs-th sort-key="firstname">Firstname</vs-th>
          <vs-th sort-key="lastname">Lastname</vs-th>
          <vs-th sort-key="nickname">Nickname</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="telephone">Telephone</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td :data="data[indextr].username">{{ data[indextr].username }}</vs-td>
            <vs-td :data="data[indextr].gender">{{ data[indextr].gender }}</vs-td>
            <vs-td :data="data[indextr].firstname">{{ data[indextr].firstname }}</vs-td>
            <vs-td :data="data[indextr].lastname">{{ data[indextr].lastname }}</vs-td>
            <vs-td :data="data[indextr].nickname">{{ data[indextr].nickname }}</vs-td>
            <vs-td :data="data[indextr].email">{{ data[indextr].email }}</vs-td>
            <vs-td :data="data[indextr].telephone">{{ data[indextr].telephone }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button @click="openConfirm()" v-if="selected!=''" color="danger" class="m-3">Delete</vs-button>
      <vs-button
        @click="editUser(),popupEdit=true"
        v-if="selected!=''"
        color="warning"
        class="m-3"
      >Edit</vs-button>
    </vx-card>
    <b class="demo-alignment">
      <vs-popup :active.sync="popupAdd" classContent="popup-example" title="New Uesr">
        <form>
          <div class="mb-3">
            <label for="username">
              <b>Username</b>
            </label>
            <vs-input
              v-validate="'required'"
              name="username"
              id="username"
              v-model="dataUserInsert.username"
              class="w-full"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('username')"
            >{{ errors.first('username') }}</span>
          </div>
          <label for="gender">
            <b>Gender</b>
          </label>
          <ul id="gender" class="demo-alignment">
            <li>
              <vs-radio v-model="dataUserInsert.gender" vs-value="M">Male</vs-radio>
            </li>
            <li>
              <vs-radio v-model="dataUserInsert.gender" vs-value="F">Female</vs-radio>
            </li>
          </ul>
          <label for="firstname">
            <b>Firstname</b>
          </label>
          <vs-input id="firstname" v-model="dataUserInsert.firstname" class="w-full mb-3" />
          <label for="lastname">
            <b>Lastname</b>
          </label>
          <vs-input id="lastname" v-model="dataUserInsert.lastname" class="w-full mb-3" />
          <label for="nickname">
            <b>Nickname</b>
          </label>
          <vs-input id="nickname" v-model="dataUserInsert.nickname" class="w-full mb-3" />
          <div class="mb-3">
            <label for="email">
              <b>Email</b>
            </label>
            <vs-input
              v-validate="'required'"
              id="email"
              name="email"
              type="email"
              v-model="dataUserInsert.email"
              class="w-full"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('email')"
            >{{ errors.first('email') }}</span>
          </div>
          <div class="mb-3">
            <label for="password">
              <b>Password</b>
            </label>
            <vs-input
              v-validate="'required'"
              id="password"
              name="password"
              v-model="dataUserInsert.password"
              type="password"
              class="w-full"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password')"
            >{{ errors.first('password') }}</span>
          </div>
          <div class="mb-3">
            <label for="confirmpassword">
              <b>Comfirm password</b>
            </label>
            <vs-input
              v-validate="'required'"
              id="confirmpassword"
              name="confirmpassword"
              v-model="dataUserInsert.confirmPassword"
              type="password"
              class="w-full"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('confirmpassword')"
            >{{ errors.first('confirmpassword') }}</span>
          </div>
          <label for="telephone">
            <b>Telephone</b>
          </label>
          <vs-input id="telephone" v-model="dataUserInsert.telephone" class="w-full mb-3" />
          <label for="locale">
            <b>Locale</b>
          </label>
          <vs-input id="locale" v-model="dataUserInsert.locale" class="w-full mb-3" />

          <label for="timezome">
            <b>Timezone</b>
          </label>
          <vs-input id="timezone" v-model="dataUserInsert.timezone" class="w-full mb-3" />

          <label for="rolesuser">
            <b>Roles</b>
          </label>
          <ul id="rolesuser" class="demo-alignment">
            <li>
              <vs-checkbox v-model="dataUserInsert.roles" vs-value="admin">Admin</vs-checkbox>
            </li>
            <!-- <li>
            <vs-checkbox v-model="dataUserInsert.roles" vs-value="supervisor">"Supervisor"</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="dataUserInsert.roles" vs-value="observe_tanker">Observe_tanker</vs-checkbox>
            </li>-->
            <li>
              <vs-checkbox v-model="dataUserInsert.roles" vs-value="supervisor">User</vs-checkbox>
            </li>
          </ul>

          <vs-button
            @click.prevent="submitForm()"
            color="primary"
            class="w-full mt-3"
            type="filled"
          >Save</vs-button>
        </form>
      </vs-popup>
    </b>
    <div class="demo-alignment">
      <vs-popup :active.sync="popupEdit" classContent="popup-example" title="Edit user">
        <label for="username">
          <b>Username</b>
        </label>
        <vs-input id="username" v-model="dataUserEdit.username" class="w-full mb-3" />

        <label for="gender">
          <b>Gender</b>
        </label>
        <ul id="gender" class="demo-alignment">
          <li>
            <vs-radio v-model="dataUserEdit.gender" vs-value="M">Male</vs-radio>
          </li>
          <li>
            <vs-radio v-model="dataUserEdit.gender" vs-value="F">Female</vs-radio>
          </li>
        </ul>
        <label for="firstname">
          <b>Firstname</b>
        </label>
        <vs-input id="firstname" v-model="dataUserEdit.firstname" class="w-full mb-3" />
        <label for="lastname">
          <b>Lastname</b>
        </label>
        <vs-input id="lastname" v-model="dataUserEdit.lastname" class="w-full mb-3" />
        <label for="nickname">
          <b>Nickname</b>
        </label>
        <vs-input id="nickname" v-model="dataUserEdit.nickname" class="w-full mb-3" />
        <label for="email">
          <b>Email</b>
        </label>
        <vs-input id="email" type="email" v-model="dataUserEdit.email" class="w-full mb-3" />
        <label for="password">
          <b>Password</b>
        </label>
        <vs-input
          id="password"
          v-model="dataUserEdit.password"
          type="password"
          class="w-full mb-3"
        />
        <label for="confirmpassword">
          <b>Comfirm password</b>
        </label>
        <vs-input
          id="confirmpassword"
          v-model="dataUserEdit.confirmPassword"
          type="password"
          class="w-full mb-3"
        />
        <label for="telephone">
          <b>Telephone</b>
        </label>
        <vs-input id="telephone" v-model="dataUserEdit.telephone" class="w-full mb-3" />
        <label for="locale">
          <b>Locale</b>
        </label>
        <vs-input id="locale" v-model="dataUserEdit.locale" class="w-full mb-3" />

        <label for="timezome">
          <b>Timezone</b>
        </label>
        <vs-input id="timezone" v-model="dataUserEdit.timezone" class="w-full mb-3" />

        <label for="rolesuser">
          <b>Roles</b>
        </label>
        <ul id="rolesuser" class="demo-alignment">
          <li>
            <vs-checkbox v-model="dataUserEdit.roles" vs-value="admin">"Admin"</vs-checkbox>
          </li>
          <!-- <li>
            <vs-checkbox v-model="dataUserInsert.roles" vs-value="supervisor">"Supervisor"</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="dataUserInsert.roles" vs-value="observe_tanker">Observe_tanker</vs-checkbox>
          </li>-->
          <li>
            <vs-checkbox v-model="dataUserEdit.roles" vs-value="supervisor">"User"</vs-checkbox>
          </li>
        </ul>
        <vs-button @click="updateUesr()" color="primary" class="w-full mt-3" type="filled">Save</vs-button>
      </vs-popup>
    </div>
  </b>
</template>


<script>
import axios from "axios";
import { API_BASE_URL } from '@/constants'

export default {
  data() {
    return {
      popupAdd: false,
      popupEdit: false,
      selected: [],
      users: [],
      dataUserInsert: {
        username: "",
        gender: "",
        firstname: "",
        lastname: "",
        nickname: "",
        email: "",
        password: "",
        confirmPassword: "",
        telephone: "",
        locale: "",
        timezone: "",
        roles: []
      },
      cleardataUserInsert: {
        username: "",
        gender: "",
        firstname: "",
        lastname: "",
        nickname: "",
        email: "",
        password: "",
        confirmPassword: "",
        telephone: "",
        locale: "",
        timezone: "",
        roles: []
      },
      dataUserEdit: {
        username: "",
        gender: "",
        firstname: "",
        lastname: "",
        nickname: "",
        email: "",
        password: "",
        confirmPassword: "",
        telephone: "",
        locale: "",
        timezone: "",
        roles: []
      },
      accessEmail: "",
      accessToken: ""
    };
  },
  mounted() {
    this.$vs.loading();

    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");

    this.$store.dispatch("updateTitlePage", "Navigation status");
    this.callUsers();
  },
  methods: {
    openConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `ยืนยันการลบ`,
        text: `คุณต้องการที่ที่จะลบผู้ใช้งาน ${this.selected.username} หรือไม่ `,
        accept: this.deleteUser
      });
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.insertUesr();
        } else {
          // form have errors
        }
      });
    },
    callUsers() {
      axios
        .get(`${API_BASE_URL}/admin/users.json`, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          this.users = response.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log("Error call apis :", error);
        });
    },
    insertUesr() {
      let formData = new FormData();
      formData.append("utf8", "✓");
      formData.append("user[username]", this.dataUserInsert.username);
      formData.append("user[gender]", this.dataUserInsert.gender);
      formData.append("user[firstname]", this.dataUserInsert.firstname);
      formData.append("user[lastname]", this.dataUserInsert.lastname);
      formData.append("user[nickname]", this.dataUserInsert.nickname);
      formData.append("user[email]", this.dataUserInsert.email);
      formData.append("user[password]", this.dataUserInsert.password);
      formData.append(
        "user[password_confirmation]",
        this.dataUserInsert.confirmPassword
      );
      formData.append("user[telephone]", this.dataUserInsert.telephone);
      formData.append("user[locale]", this.dataUserInsert.locale);
      formData.append("user[timezone]", this.dataUserInsert.timezone);
      formData.append("user[roles][]", this.dataUserInsert.roles);
      axios
        .post(
          `${API_BASE_URL}/admin/users`,
          formData,

          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          }
        )
        .then(response => {
          this.callUsers();
          this.dataUserInsert = this.cleardataUserInsert;
          this.popupAdd = false;
        })
        .catch(error => {
          console.log("Error call apis :", error);
          this.popupAdd = false;
        });
    },
    editUser() {
      this.dataUserEdit.username = this.selected.username;
      this.dataUserEdit.gender = this.selected.gender;
      this.dataUserEdit.firstname = this.selected.firstname;
      this.dataUserEdit.lastname = this.selected.lastname;
      this.dataUserEdit.nickname = this.selected.nickname;
      this.dataUserEdit.email = this.selected.email;
      this.dataUserEdit.password = "";
      this.dataUserEdit.confirmPassword = "";
      this.dataUserEdit.telephone = this.selected.telephone;
      this.dataUserEdit.locale = this.selected.locale;
      this.dataUserEdit.timezone = this.selected.timezone;
      this.dataUserEdit.roles = this.selected.roles;
      this.popupEdit = true;
    },
    updateUesr() {
      let formData = new FormData();
      formData.append("utf8", "✓");
      formData.append("user[username]", this.dataUserEdit.username);
      formData.append("user[gender]", this.dataUserEdit.gender);
      formData.append("user[firstname]", this.dataUserEdit.firstname);
      formData.append("user[lastname]", this.dataUserEdit.lastname);
      formData.append("user[nickname]", this.dataUserEdit.nickname);
      formData.append("user[email]", this.dataUserEdit.email);
      formData.append("user[password]", this.dataUserEdit.password);
      formData.append(
        "user[password_confirmation]",
        this.dataUserEdit.confirmPassword
      );
      formData.append("user[telephone]", this.dataUserEdit.telephone);
      formData.append("user[locale]", this.dataUserEdit.locale);
      formData.append("user[timezone]", this.dataUserEdit.timezone);
      formData.append("user[roles][]", this.dataUserEdit.roles);
      axios
        .put(
          `${API_BASE_URL}/admin/users/${this.selected.id}`,
          formData,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          }
        )
        .then(response => {
          this.callUsers();
          this.dataUserInsert = this.cleardataUserInsert;
          this.popupEdit = false;
        })
        .catch(error => {
          this.callUsers();
          console.log("Error call apis :", error);
          this.popupEdit = false;
        });
    },
    deleteUser() {
      this.$vs.loading();
      axios
        .delete(
          `${API_BASE_URL}/admin/users/${this.selected.id}`,
          {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          }
        )
        .then(response => {
          this.callUsers();
          this.$vs.loading.close();
        })
        .catch(error => {
          this.callUsers();
          this.$vs.loading.close();
          console.log("Error call apis :", error);
        });
    }
  }
};
</script>

<style>
.demo-alignment > * {
  margin-top: 0;
}
.con-vs-popup .vs-popup {
  width: 1000px;
}
</style>